import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

const TEAM_IMG =
  "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?ixlib=rb-4.0.3&auto=format&fit=crop&w=1400&q=80";

export default function About() {
  const { t } = useLang();
  const a = t.about;
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-7">
          <p className="eyebrow">{a.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#0B192C] leading-[1.05]" data-testid="about-title">{a.title}</h1>
          <p className="mt-8 text-lg text-slate-600 leading-relaxed max-w-xl">{a.body1}</p>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed max-w-xl">{a.body2}</p>
        </Reveal>
        <Reveal delay={200} className="lg:col-span-5">
          <div className="aspect-[4/5] w-full overflow-hidden rounded-[24px] border border-slate-100">
            <img src={TEAM_IMG} alt="" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="border-t border-slate-100 bg-[#F8F9FA] py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal><p className="eyebrow">{a.valuesTitle}</p></Reveal>
          <div className="mt-10 grid md:grid-cols-3 gap-10">
            {a.values.map((v, i) => (
              <Reveal key={v.h} delay={i * 100} className="border-t border-[#C2A878]/60 pt-6">
                <h3 className="font-serif text-2xl text-[#0B192C]">{v.h}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{v.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <Reveal><p className="eyebrow">{a.teamTitle}</p></Reveal>
        <div className="mt-10 grid md:grid-cols-3 gap-8">
          {a.team.map((m, i) => (
            <Reveal key={m.name} delay={i * 100} className="rounded-[24px] border border-slate-100 p-8">
              <div className="h-14 w-14 rounded-full bg-[#0B192C] text-[#C2A878] font-serif text-xl flex items-center justify-center">
                {m.name.charAt(0)}
              </div>
              <h3 className="font-serif text-2xl text-[#0B192C] mt-6">{m.name}</h3>
              <p className="font-display text-xs tracking-[0.2em] uppercase text-[#C2A878] mt-1">{m.role}</p>
              <p className="mt-4 text-slate-600 leading-relaxed text-sm">{m.bio}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={200} className="mt-14">
          <Link to="/registro" className="btn-primary" data-testid="about-cta">{t.landing.cta} <ArrowRight className="h-4 w-4" /></Link>
        </Reveal>
      </section>
    </div>
  );
}
